import styled from 'styled-components';
import Img from '@pagerland/common/src/components/Img';

export const StyledImg = styled(Img)`
  cursor: pointer;
`;
